import styled, { css } from 'styled-components'
import { StyledParagraph } from '../Paragraph/Paragraph.style'

export const CopyBtn = styled.span`
  ${({ theme }) => css`
    cursor: pointer;
    display: block;

    svg {
      display: block;
      fill: ${theme.colors.greySemiDark};
    }
  `}
`

export const StyledCopyParagraph = styled(StyledParagraph)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    border-radius: 4px;
    padding-right: 8px;

    ${CopyBtn} {
      visibility: hidden;
      margin-left: 8px;
    }

    &:hover {
      background: ${theme.colors.greyLight};

      & > ${CopyBtn} {
        visibility: visible;
      }
    }
  `}
`
